<script>
import resources from '../advanced/resources'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'agenda-search-basic',
  data () {
    return {
      force_speciality: false,
      force_professional: false,
      agenda: {
        location: {
          distance: null
        }
      }
    }
  },
  mixins: [resources],
  validations: {
    agenda: {
      professional: {
        id: {
          required
        }
      },
      speciality: {
        id: {
          required
        }
      }
    }
  }
}
</script>

<template lang="pug">
page
  h2(slot="title")
    span.first-line
      span.icon 
      |  Agendar Consultas
    span.hifen  —
    span.second-line Selecione o tipo de Pesquisa
  spinner(v-show="loading")
  .col-xs-12.content(v-if="!loading")
    .container-fluid
      .row
        .col-xs-12.white-bg
          .row
            .col-xs-12.agendamentos-list
              .list-item
                .icon
                  span.icon 
                v-input(:status="$v.agenda.speciality.id.$error ? 'error' : null")
                  f-select-speciality(
                    v-model="agenda.speciality.id",
                    label="Especialidade Médica",
                    @selected="onSelectedSpeciality")

                small Desejo encontrar profissionais pela sua especialidade médica
                button.btn.save-filled(@click.prevent="doSearchBySpeciality()")
                  span.icon 
                  |  Buscar
                router-link(:to="{name: 'patient.agendas.search.speciality'}")
                  button.btn.find
                    span.icon 
                    |  Refinar Busca
              .list-item
                .icon
                  span.icon 
                v-input(:status="$v.agenda.professional.id.$error ? 'error' : null")
                  f-select-professional(
                    v-model="agenda.professional.id",
                    label="Nome do Profissional",
                    @selected="onSelectedProfessional",
                    placeholder="Nome ou CRM do Profissional")

                small
                  | Já conheço o profissional,
                  br
                  | desejo apenas ver as suas agendas
                button.btn.save-filled(@click.prevent="doSearchByProfessional()")
                  span.icon 
                  |  Buscar
                router-link(:to="{name: 'patient.agendas.search.professional'}")
                  button.btn.find()
                    span.icon 
                    |  Refinar Busca
              .list-item.busca-avancada
                .icon
                  span.icon 
                h4.text-center Pesquisa Avançada
                small
                  | Desejo encontrar profissionais
                  br
                  | por meio de critérios específicos
                router-link(:to="{name: 'patient.agendas.search.advanced'}")
                  button.btn.find-filled(type='submit')
                    span.icon 
                    |  Refinar Busca
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/basic/agenda.vue